import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { SuccessIcon, RemoveIcon } from 'foundations-assets';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcceptedStatusInfoContainer = styled.div.withConfig({
  displayName: "AcceptedStatusInfo__AcceptedStatusInfoContainer",
  componentId: "c401b1-0"
})(["align-self:start;vertical-align:baseline;"]);
const AcceptedStatusInfo = ({
  acceptedStatus,
  displayMode
}) => {
  switch (acceptedStatus) {
    case 'ACCEPTED':
      return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
        children: [/*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(SuccessIcon, {
            color: "do-not-use-oz"
          })
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.metCriteria"
        })]
      });
    case 'REJECTED':
      {
        if (displayMode === 'OPTIMISTIC_ACCEPTED') {
          return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
            children: [/*#__PURE__*/_jsx(UIHelpIcon, {
              className: "m-right-2",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.noEvalData"
              }),
              tooltipPlacement: "left"
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.metCriteria"
            })]
          });
        }
        return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
          children: [/*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(RemoveIcon, {
              color: "do-not-use-candy-apple"
            })
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.didNotMeetCriteria"
          })]
        });
      }
    default:
      return null;
  }
};
export default AcceptedStatusInfo;